/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Actions for traktor-middleware
 */

import { EVENT } from './constants'

/**
 * should be the `Location` from `@zcode/state-type`, with properties like
 * `box`, `country`, `cityName`, `lat`, `lng`, ...
 */
export type Location = object & { readonly href?: never }

export interface User {
  readonly userId: number | undefined
  readonly email: string | undefined
}

export interface TrackEventPayload {
  name: string
  filters?: object | undefined
  location?: Location
  props?: object
  user?: User
  /** defaults to true */
  sendToOptimizely?: boolean
}

export const event = <Payload extends TrackEventPayload>(payload: Payload) =>
  ({
    payload,
    type: EVENT,
  }) as const
